import { useState } from "react";
import DonationsSC from "./donations.styles";
import Community1 from '../../../assets/community/community_1.jpg';
import Community2 from '../../../assets/community/community_2.jpeg';
import Talk3 from '../../../assets/moments/talk_3.jpeg'


const cards = [
    {
        id: 1,
        title: "Government School Visit",
        image: Community1
    },
    {
        id: 2,
        title: "Gnana Jyothi Trust for Specially Abled",
        image: Community2
    },
    {
        id: 3,
        title: "Mental Health Awareness Session",
        image: Talk3
    }
];

const Donations = ({ ref }) => {
    const [activeId, setActiveId] = useState(1); // default first expanded

    return (
        <DonationsSC>
            <div className="section-title" ref={ref}>
                COMMUNITY CONTRIBUTIONS
            </div>
            <div className="section-subtitle">
                Extending mental health support beyond clinics — from free sessions for blind students to village outreach and care for the society.
            </div>
            <div className="grid-container">
                {cards.map((card) => (
                    <div
                        key={card.id}
                        className={`card ${activeId === card.id ? "active" : ""}`}
                        onClick={() => setActiveId(card.id)}
                        style={{ backgroundImage: `url(${card.image})` }}
                    >
                        <div className="overlay">
                            <h3>{card.title}</h3>
                        </div>
                    </div>
                ))}
            </div>
            <div className="donation-action-text">
                “Together, we can make care accessible to those who need it most.
                <br />
                Join hands and be the reason someone feels supported today.”
            </div>
        </DonationsSC>
    );
}

export default Donations;